import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-348f1726"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "boxed-container text-center mt-16" }

import useAlert from '@/composables/useAlert';
import { IonButton } from '@ionic/vue';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'SurveyMapFragenblockButtons',
  emits: ['delete', 'save'],
  setup(__props, { emit }) {


const { t } = useI18n({ useScope: 'global' })
const alert = useAlert();

function displayAlert() {
  alert.showAdv(
    t("alerts.deleteTitle"),
    t("alerts.deleteDescription"),
    [
      { text: t("alerts.deleteCancel"), },
      { text: t("alerts.deleteConfirm"), handler: () => { emit('delete')} },
    ]
  )
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(IonButton), {
        fill: "clear",
        color: "danger",
        class: "d-button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (displayAlert()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("buttons.loeschen")), 1)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})